import {
  Typography,
  CssBaseline,
  Box,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Header from "./Header";
// At the top of your App.jsx or index.jsx
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import About from "./pages/About";
import Outlets from "./pages/Outlets";
import Catering from "./pages/Catering";
import { Analytics } from '@vercel/analytics/react';


const theme = createTheme({
  palette: {
    primary: { main: "#5D3A00" }, // dark coffee brown
    secondary: { main: "#FFCA28" }, // yellow-orange
  },
  typography: {
    fontFamily: "'Playfair Display', serif",
  },
});


const Footer = () => (
  <Box sx={{ py: 4, bgcolor: "#FFF3E0", textAlign: "center" }}>
    <Typography variant="body2" color="textSecondary">
      &copy; {new Date().getFullYear()} Kulche Shulche. All rights reserved.
    </Typography>
  </Box>
);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
     <Router>
      <Header />
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="outlets/:slug" element={<Outlets />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/catering" element={<Catering />} />
      </Routes>
    </Router>
      <Footer />
      <Analytics />
    </ThemeProvider>
  );
}
